import { buildModelManager } from "../builder.js";
const DefaultMicuDeviceInstanceSelection = {
  __typename: true,
  id: true,
  caseId: true,
  createdAt: true,
  currentSettings: true,
  deviceType: true,
  updatedAt: true
};
const modelApiIdentifier = "micuDeviceInstance";
const pluralModelApiIdentifier = "micuDeviceInstances";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMicuDeviceInstanceSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMicuDeviceInstanceSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMicuDeviceInstanceSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMicuDeviceInstanceSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMicuDeviceInstanceSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMicuDeviceInstanceSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMicuDeviceInstanceSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "micuDeviceInstanceGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const MicuDeviceInstanceManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultMicuDeviceInstanceSelection,
  operations
);
export {
  DefaultMicuDeviceInstanceSelection,
  MicuDeviceInstanceManager
};
//# sourceMappingURL=MicuDeviceInstance.js.map
